export default function AverageRelativeAbundanceForOverlappingTaxon({ subSampleTaxaData, rank, overlappingThreshold }) {

    // console.log(subSampleTaxaData);

    const processedData = Object.entries(subSampleTaxaData).map(([sampleId, sampleTaxaData]) => {
        const filteredByRank = sampleTaxaData.filter(item => item.taxon.rank === rank);
        return { sampleId, filteredByRank }
    });
    // console.log(processedData);


    let taxonRelativeAbundances = {};
    let taxonOccurrences = {};

    processedData.forEach(sample => {
        sample.filteredByRank.forEach(item => {
            const taxonId = item.taxon.ncbi_id;
            if (!taxonRelativeAbundances[taxonId]) {
                taxonRelativeAbundances[taxonId] = {
                    name: item.taxon.name,
                    relativeAbundance: 0
                };
                taxonOccurrences[taxonId] = 0;
            }
            taxonRelativeAbundances[taxonId].relativeAbundance += item.relative_abundance;
            taxonOccurrences[taxonId]++;
        });
    });

    // console.log(processedData);


    // filter taxa that appear in at least overlappingThreshold samples
    const thresholdTaxa = Object.keys(taxonOccurrences)
        .filter(taxonId => taxonOccurrences[taxonId] >= overlappingThreshold)
        .map(Number);

    // console.log(thresholdTaxa);


    const result = thresholdTaxa.map(taxonId => ({
        taxonId,
        name: taxonRelativeAbundances[taxonId].name,
        totalRelativeAbundance: taxonRelativeAbundances[taxonId].relativeAbundance,
        avgRelativeAbundance: taxonRelativeAbundances[taxonId].relativeAbundance / processedData.length,
        sampleCount: taxonOccurrences[taxonId]
    })).filter(item => item.totalRelativeAbundance > 0 && item.avgRelativeAbundance > 0);




    // console.log(result);


    // console.log(result);

    return result;
}